import {
  startOfWeek,
  getISOWeek,
  setISOWeek,
  addDays,
} from "date-fns";

// ============ ZOOM LEVELS ============
export const ZOOM_LEVELS = {
  compact: { rowHeight: 64, dayWidth: 96, label: "Kompakt" },
  standard: { rowHeight: 100, dayWidth: 130, label: "Standard" },
  large: { rowHeight: 130, dayWidth: 160, label: "Baustelle" },
};

export const DEFAULT_ZOOM = "standard";

// ============ GRID CONSTANTS ============
export const DEFAULT_DAILY_CAPACITY = 10;
export const RESIZE_SNAP = 0.5;
export const DAY_WIDTH = ZOOM_LEVELS.standard.dayWidth;
export const ROW_HEIGHT = ZOOM_LEVELS.standard.rowHeight;
export const VISIBLE_DAYS_BUFFER = 21;
export const EMPLOYEE_COL_WIDTH = 150;
export const CELL_PADDING = 4;
export const AUTO_SAVE_DELAY = 700;

// ============ CARD COLORS ============
export const CARD_BG = "var(--tga-bg-content)";
export const CARD_BG_HOVER = "#263548";
export const GRID_BG = "var(--tga-bg-app)";
export const GRID_CELL_BG = "var(--tga-bg-card)";
export const WEEKEND_BG = "var(--tga-bg-app)";

// ============ STATUS COLORS ============
export const STATUS_COLORS = {
  planned:   { bg: "#1E3A5F", text: "#60A5FA", label: "Geplant",  color: "var(--tga-blue)" },
  confirmed: { bg: "#14412A", text: "#4ADE80", label: "Best.",    color: "#10B981" },
  blocked:   { bg: "#2E1A52", text: "#A78BFA", label: "BLOCK",   color: "#8B5CF6" },
};

export const DELTA_COLORS = {
  ok:       { text: "text-green-400" },
  warning:  { text: "text-yellow-400" },
  critical: { text: "text-red-400" },
};

// ============ HELPER FUNCTIONS ============
export function getCapacityColor(hours, capacity = DEFAULT_DAILY_CAPACITY) {
  const u = hours / capacity;
  if (u <= 0) return "var(--tga-text-dim)";
  if (u < 0.8) return "#4ADE80";
  if (u <= 1) return "#FACC15";
  return "#F87171";
}

export function hasConflict(hours, capacity = DEFAULT_DAILY_CAPACITY) {
  return hours > capacity;
}

export function getWeekMonday(date) {
  return startOfWeek(date, { weekStartsOn: 1 });
}

export function getWeekDateRange(year, week) {
  let date = new Date(year, 0, 4);
  date = setISOWeek(date, week);
  const monday = startOfWeek(date, { weekStartsOn: 1 });
  const sunday = addDays(monday, 6);
  return { monday, sunday };
}

export function getMaxISOWeeks(year) {
  const dec28 = new Date(year, 11, 28);
  return getISOWeek(dec28);
}
